// extracted by mini-css-extract-plugin
export default {"wrapper":"RingsTabContent_wrapper__CiZCC","emptyText":"RingsTabContent_emptyText__lBAfi"};